import { useIntl } from 'react-intl';
import SegmentedControl from '@alltrails/denali/components/SegmentedControl';
import { LayerType, TwoTabLayerType } from '../../types/LayerMenu';
import styles from './LayerMenu.module.scss';

type Props<T extends LayerType | TwoTabLayerType> = {
  layerType: T;
  options: Array<{ id: T; label: string }>;
  onLayerTypeChange: (newLayerType: T) => void;
};

const LayerControl = <T extends LayerType | TwoTabLayerType>({ layerType, options, onLayerTypeChange }: Props<T>) => {
  const intl = useIntl();
  if (options.length <= 1) {
    return null;
  }

  return (
    <SegmentedControl
      activeId={layerType}
      ariaLabel={intl.formatMessage({ defaultMessage: 'Layer type' })}
      className={styles.segmentedControl}
      onChange={onLayerTypeChange}
      options={options}
      width="full"
    />
  );
};

export default LayerControl;
